import { createContext } from 'react';
import FeatureFlagContainer from '../FeatureFlagContainer';

const defaultContainer = new FeatureFlagContainer();

export default createContext(defaultContainer);
